import { cisPost } from './index';

export const cisStatic = params => cisPost("/cis/feeds", params);


// WEBPACK FOOTER //
// ./src/cisService/api.js